/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownScholarshipOfferStatus } from '../models/db_DropdownScholarshipOfferStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ScholarshipOfferStatuses {
    /**
     * Get a list of scholarship offer statuses
     * @returns db_DropdownScholarshipOfferStatus OK
     * @throws ApiError
     */
    public static listScholarshipOfferStatuses(): CancelablePromise<Array<db_DropdownScholarshipOfferStatus>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/scholarship-offer-statuses',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
